import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "actions", "blankPhotoPages"]
  declare readonly checkboxTarget: HTMLInputElement
  declare readonly actionsTarget: HTMLElement
  declare readonly blankPhotoPagesTarget: HTMLElement
  declare readonly hasCheckboxTarget: boolean
  declare readonly hasActionsTarget: boolean
  declare readonly hasBlankPhotoPagesTarget: boolean

  connect() {
    this.update()
  }

  toggle() {
    this.update()
  }

  update() {
    const checked = this.hasCheckboxTarget ? this.checkboxTarget.checked : false
    if (this.hasActionsTarget) {
      this.actionsTarget.classList.toggle("hidden", !checked)
      this.actionsTarget.classList.toggle("d-none", !checked)
    }
    if (this.hasBlankPhotoPagesTarget) {
      this.blankPhotoPagesTarget.classList.toggle("hidden", !checked)
      this.blankPhotoPagesTarget.classList.toggle("d-none", !checked)
    }
  }
}
